module.exports = __webpack_public_path__ + "img/special_whiteningessence_202410.7331e7a5.jpg";